import React, { useState } from 'react'
import Button from '../../../components/buttons/button'
import toast from 'react-hot-toast';
import { ArrowLeft, FileText } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useCreateFileMutation } from '../../../store/Reducer/file';
import { useCreateAzanTimeMutation, useUpdateiqamahdelayMutation } from '../../../store/Reducer/prayertimes';
import BackButton from '../../../components/buttons/BackButton';

const PrayerTimeIqamahImport = () => {

    const [isLoading, setIsLoading] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);

    // Mutations
    const [createFile, { isLoading: fileLoading }] = useCreateFileMutation();
    const [updateiqamahdelay] = useUpdateiqamahdelayMutation();
    const { t } = useTranslation()
    const navigate = useNavigate()

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFile(file);
        } else {
            toast.error('Please select a valid file.');
        }
    };

    // Handle file upload and subsequent Azan time creation
    const handleSave = async () => {
        if (!selectedFile) {
            toast.error('No file selected!');
            return;
        }

        setIsLoading(true);

        try {
            // Upload the file

            const fileResponse = await createFile(selectedFile).unwrap();

            // Extract the file name from the response
            const fileName = fileResponse.data?.fileName;

            if (!fileName) {
                throw new Error('Invalid file response format');
            }

            // Send the file name to createAzanTime
            const azanPayload = { file: { name: fileName } };

            const azanTimeResponse = await updateiqamahdelay(azanPayload).unwrap();

            toast.success('File uploaded and Azan time created successfully!');
            console.log('Azan Time Response:', azanTimeResponse);
            navigate(-1);
        } catch (error) {
            toast.error(error?.data?.message || "An error occurred");
        } finally {
            setIsLoading(false);
        }
    };



    return (
        <>
            <section className="py-4 px-4 w-full">

                <div className="text-start mb-4">
                    <h1 className="text-2xl text-start font-semibold text-slate-800 flex items-center">
                        <BackButton /> {t('back')}
                    </h1>
                </div>


                <div className="w-full mx-auto pt-3 pb-4 px-3">

                    <h2 className="text-start text-2xl font-medium text-slate-700 mb-4">
                        {t("upload_prayers_timetable")}
                    </h2>
                    <h2 className="py-4 px-4 text-start text-md font-normal border border-blue-500 bg-blue-100 text-blue-600 rounded-lg mb-8">
                        {t("iqamah_time_prayers_template")}
                    </h2>

                    <div className="drop w-full">
                        <div className="flex items-center justify-center mx-auto">
                            <label
                                htmlFor="dropzone-file"
                                className="flex flex-col items-center justify-center w-full h-52 sm:h-64 border-2 border-gray-400 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 "
                            >
                                <div className="flex flex-col items-center justify-center pt-5 pb-6">
                                    <svg
                                        className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                                        aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 20 16"
                                    >
                                        <path
                                            stroke="currentColor"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                                        />
                                    </svg>
                                    <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                                        <span className="font-semibold">Click to upload</span> or drag
                                        and drop
                                    </p>
                                    <p className="text-xs text-gray-500 dark:text-gray-400">
                                        CSV or XLSX

                                    </p>
                                    {selectedFile && (
                                        <div className="mt-4 flex items-center bg-gray-100 p-3 rounded-lg">
                                            <FileText className="w-6 h-6 text-gray-600 mr-2" />
                                            <span className="text-gray-700 text-sm font-medium">{selectedFile.name}</span>
                                        </div>
                                    )}
                                </div>
                                <input
                                    id="dropzone-file"
                                    type="file"
                                    className="hidden"
                                    onChange={handleFileChange}
                                />
                            </label>
                        </div>
                    </div>

                    <div className="mt-6 w-full flex justify-center items-center">
                        <Button
                            text={t("upload_file_button")}
                            type="primary"
                            className="w-full py-2.5"
                            onClick={handleSave}
                            loading={isLoading}
                        />
                    </div>

                </div>
            </section>
        </>
    )
}

export default PrayerTimeIqamahImport
